import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { useMap } from 'react-leaflet';

import L from 'leaflet';

const WMSLegend = (props) => {
  const map = useMap();

  useEffect(() => {
    console.log('WMSLegend useEffect map props', map, props);
    const { legend } = props;
    const legendControl = L.control({ position: 'bottomright' });

    const jsx = (
      <div className="legend" id="legend">
        <img src={legend} alt="legend" />
      </div>
    );
    legendControl.onAdd = function () {
      const div = L.DomUtil.create('div', 'info legend');
      ReactDOM.render(jsx, div);
      return div;
    };

    map.addControl(legendControl);
    return () => map.removeControl(legendControl);
  }, [map, props]);
  return null;
};

WMSLegend.propTypes = {
  legend: PropTypes.string,
};

WMSLegend.propTypes = {
  legend: '',
};

export default WMSLegend;
